const LAYOUT_HEADER_HEIGHT = 54;
const LAYOUT_TAG_HEIGHT = 0;
export { LAYOUT_HEADER_HEIGHT, LAYOUT_TAG_HEIGHT };
